import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/shared/ui/alert-dialog.tsx"
import { useDiscardEvent } from "../api/themes"

type Props = {
  id: number,
  trigger: JSX.Element,
  onDelete: () => void
}

const DiscardDialog = ({ id, trigger, onDelete }: Props) => {

  const { discardEvent } = useDiscardEvent()

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        {trigger}
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete this theme
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => onDelete()}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={() => {
            discardEvent(id)
            onDelete()
          }}>Continue</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default DiscardDialog;
